export const IsUserPartOfAnOrganization = (id, name, logo) => {

    if (id === null || name === null || logo === null) return false
    return true

}

export const IsUserTrainingChartBetaTester = (email) => {

    switch (email) {
        case "holden@kinesisintegrated.com": return true
        case "jacob@whichweight.com": return true
        case "chris@kinesisintegrated.com": return true
        case "paul@bluecollaret.com": return true
        case "integratedstridecoaching@gmail.com": return true
        case "jackson@kinesisintegrated.com": return true
        case "jgavprior@gmail.com": return true
        case "matthew@wyldendurance.com": return true
        case "collenmclain02@gmail.com": return true
        case "kdunn@strengthenyourstride.coach": return true
        case "coachcat@catberad.com": return true
        case "leesilverbackrunner@gmail.com": return true
        case "test-rbac@gmail.com": return true
        default: return false
    }

}

export const GetKinesisProfileType = (kinesisUserGroupId, userId) => {

    if (kinesisUserGroupId !== null && userId === null) return 'group'

    if (kinesisUserGroupId !== null && userId !== null) return 'group-individual'

    if (kinesisUserGroupId === null && userId !== null) return 'individual'

    return 'unknown'
    
}

export const GetRoles = () => {
    return [
        'super-admin',
        'organization-owner',
        'organization-admin',
        'trainer'
    ]
}

export const ConvertRoleToDisplayName = (role) => { 
    switch (role) {
        case 'super-admin': return 'Super Admin'
        case 'organization-owner': return 'Organization Owner'
        case 'organization-admin': return 'Organization Admin'
        case 'trainer': return 'Coach'
        default: return 'None'
    }
}